import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { isBlockedDomain } from 'app/utils/url-security.utils';

if ( environment.production )
{
    enableProdMode();
}

const blockGoogleTranslateScript = () => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node instanceof HTMLScriptElement && node.src && isBlockedDomain(node.src)) {
                    console.warn('Blocked dynamically added Google Translate script:', node.src);
                    node.remove();
                }
            });
        });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
};

blockGoogleTranslateScript();

platformBrowser().bootstrapModule(AppModule).catch(err => console.log(err));